import React, { Component } from "react";
import PropTypes from "prop-types";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import Axios from "axios";

class Review extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      company: "",
      email: "",
      mobile: "",
      state: "",
      city: "",
      message: "",
      whiteColor: {color:"white"}
    };
  }

  componentWillMount() {
    const { steps } = this.props;
    const { name, company, email, mobile, state, city, message } = steps;
    this.setState({ name, company, email, mobile, state, city, message });
  }

  render() {
    const { name, company, email, mobile, state, city, message } = this.state;
    return (
      <div style={{ width: "100%" }}>
        <p>If you have queries please <b><a style={this.state.whiteColor} href ="https://buyadsonbigfm.com/contact">click here</a></b> or click on <a style={this.state.whiteColor} href="https://buyadsonbigfm.com/contact">https://buyadsonbigfm.com/contact</a></p>
        {/* <h3>Summary</h3>
        <table>
          <tbody>
            <tr>
              <td>Name</td>
              <td>{name.value}</td>
            </tr>
            <tr>
              <td>Company</td>
              <td>{company.value}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{email.value}</td>
            </tr>
            <tr>
              <td>Mobile</td>
              <td>{mobile.value}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{state && state.value}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{city && city.value}</td>
            </tr>
            <tr>
              <td>Message</td>
              <td>{message.value}</td>
            </tr>
          </tbody>
        </table> */}
      </div>
    );
  }
}

Review.propTypes = {
  steps: PropTypes.object,
};

Review.defaultProps = {
  steps: undefined,
};

class SimpleForm extends Component {
  config = {
    width: "530px",
    height: "450px",
    floating: true,
  };
  async handleEnd({ steps }) {
    /* let  { name, company, email, mobile, state, city, message } = steps;
    let params ={
        name: name.value,
        company: company.value,
        email: email.value,
        mobile: mobile.value,
        state: state.value,
        city: city.value,
        message: message.value
    }
    await Axios.post(endPoints.contact, params) */
  }

  steps = [
    {
      id: "Greet",
      message: "Hi there ! Welcome to buyadsonbigfm.com.",
      trigger: "review",
    },
    {
      id: "Ask Name",
      message: "Please enter your name?",
      trigger: "review",
    },
    {
      id: "name",
      user: true,
      trigger: "Asking user for query",
      validator:(value)=>{
          if(!value.trim()){
              return 'Name should not be empty'
          }
          return true
      }
    },
    {
      id: "Asking user for query",
      message: "Hi {previousValue}, Do You have queries to ask with bigfm!",
      trigger: () => "Displaying options to eat",
    },
    {
      id: "Displaying options to eat",
      options: [
        {
          value: "Yes",
          label: "Yes",
          trigger: "Enter Company Name",
        },
        {
          value: "No",
          label: "No",
          trigger: "Done",
        },
      ],
    },
    {
      id: "Enter Company Name",
      message: "Please enter your company name?",
      trigger: "company",
    },
    {
      id: "company",
      user: true,
      trigger: "Asking user for email",
      validator:(value)=>{
        if(!value.trim()){
            return 'Company Name should not be empty'
        }
        return true
    }
    },
    {
      id: "Asking user for email",
      message: "Please enter your Valid Email?",
      trigger: "email",
    },
    {
      id: "email",
      user: true,
      validator: (value) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let email = re.test(String(value).toLowerCase());
        if (!email) {
          return "Enter a valid email";
        }
        return true;
      },
      trigger: "Asking user for mobile",
    },
    {
      id: "Asking user for mobile",
      message: "Please enter your Mobile Number?",
      trigger: "mobile",
    },
    {
      id: "mobile",
      user: true,
      validator: (value) => {
        const re = /^[789]\d{9}$/;
        let mobile = re.test(String(value).toLowerCase());
        if (!mobile) {
          return "Enter a valid mobile number";
        }
        return true;
      },
      trigger: "Asking user for message",
    },
    {
      id: "Asking user for message",
      message: "Please enter your Query?",
      trigger: "message",
    },
    {
      id: "message",
      user: true,
      trigger: "summary",
    },
    {
      id: "summary",
      message: "Great! Check out your summary",
      trigger: "review",
    },
    {
      id: "review",
      component: <Review />,
      asMessage: true,
      end: true,
      trigger: "update",
    },
    {
      id: "update",
      message: "Would you like to update some field?",
      trigger: "update-question",
    },
    {
      id: "update-question",
      options: [
        { value: "yes", label: "Yes", trigger: "update-yes" },
        { value: "no", label: "No", trigger: "Submit Query" },
      ],
    },
    {
      id: "update-yes",
      message: "What field would you like to update?",
      trigger: "update-fields",
    },
    {
      id: "update-fields",
      options: [
        { value: "name", label: "Name", trigger: "update-name" },
        { value: "company", label: "Company", trigger: "update-company" },
        { value: "mobile", label: "Mobile", trigger: "update-mobile" },
        { value: "email", label: "Email", trigger: "update-email" },
        { value: "state", label: "State", trigger: "update-state" },
        { value: "city", label: "City", trigger: "update-city" },
        { value: "message", label: "Query", trigger: "update-message" },
      ],
    },
    {
      id: "update-name",
      update: "name",
      trigger: "summary",
    },
    {
      id: "update-company",
      update: "company",
      trigger: "summary",
    },
    {
      id: "update-mobile",
      update: "mobile",
      trigger: "summary",
    },
    {
      id: "update-email",
      update: "email",
      trigger: "summary",
    },
    {
      id: "update-state",
      update: "state",
      trigger: "summary",
    },
    {
      id: "update-city",
      update: "city",
      trigger: "summary",
    },
    {
      id: "update-message",
      update: "message",
      trigger: "summary",
    },
    {
      id: "Done",
      message: "Have a great day !!",
      end: true,
    },
    {
      id: "Submit Query",
      message: "Thanks! Your data was submitted successfully!",
      trigger:"Done"
    },
  ];

  theme = {
    background: "white",
    fontFamily: "Arial, Helvetica, sans-serif",
    headerBgColor: "orange",
    headerFontColor: "#fff",
    headerFontSize: "25px",
    botBubbleColor: "#1c9de6",
    // botBubbleColor: "linear-gradient(90deg, #1e81c6, #1c9de6)",
    botFontColor: "#fff",
    userBubbleColor: "#fff",
    userFontColor: "#4c4c4c",
  };
  render() {
    return (
      <ThemeProvider theme={this.theme}>
        <ChatBot handleEnd={this.handleEnd} steps={this.steps} {...this.config} />
      </ThemeProvider>
    );
  }
}

export default SimpleForm;



// WEBPACK FOOTER //
// ./web/components/Widget/chatbot.js